import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function deleteFeedback(feedbackId: string) {
	const response = await fetch(`${apiEndpoint}/feedback/${feedbackId}`, {
		method: 'DELETE',
		headers: await standardHeaders(),
		mode: 'cors'
	});
	if (response.ok) {
		return await response.json();
	}
	return null;
}